import clsx from "clsx";
import { useQueryState } from "nuqs";
import { cloneElement, useEffect } from "react";

import { TabHeaders, Tabs } from "@transfr-inc/dashboard-components";
import { Product } from "@transfr-inc/dashboard-components/constants";
import { getProduct } from "@transfr-inc/dashboard-components/utils";

import { productParser } from "@lib/utils/search-params-parsers";
import { NoProductsNotification } from "@views/dashboard/components/no-products.notification";
import { getProductTabComponent } from "@views/dashboard/views/get-product.tab";

import { ProfessionalLearningProduct } from "@components/custom/dropdowns/product-dropdown-list";

import { CeTab } from "./ce.tab";
import { ProgramTab } from "./program.tab";
import { TrekTab } from "./trek.tab";
import { TsTab } from "./ts.tab";

import "./product.tabs.scss";

const hasProduct = (data, product) => !!data?.find((d) => d === product.id);

export const ProductTabs = ({ products, professionalLearning }) => {
  const tsProduct = getProduct(Product.TS);
  const ceProduct = getProduct(Product.CE);
  const trekProduct = getProduct(Product.TRK);
  const programProduct = getProduct(Product.PROG);

  const [selectedProductTab, setSelectedProductTab] = useQueryState(
    "product",
    productParser()
  );

  const setTabState = (tabName) => setSelectedProductTab(tabName);

  const tsProductTab = getProductTabComponent(tsProduct, <TsTab />);
  const ceProductTab = getProductTabComponent(ceProduct, <CeTab />, {
    headerText: (
      <>
        Trek<span>(VR)</span>
      </>
    ),
  });
  const trekProductTab = getProductTabComponent(trekProduct, <TrekTab />, {
    headerText: (
      <>
        Trek<span>(Mobile)</span>
      </>
    ),
  });
  const programProductTab = getProductTabComponent(
    programProduct,
    <ProgramTab />
  );
  const plProductTab = getProductTabComponent(
    ProfessionalLearningProduct,
    <ProgramTab professionalLearning />
  );

  const getProductTabs = () => {
    const tabs = [];
    hasProduct(products, tsProduct) && tabs.push(tsProductTab);
    hasProduct(products, ceProduct) && tabs.push(ceProductTab);
    hasProduct(products, trekProduct) && tabs.push(trekProductTab);
    hasProduct(products, programProduct) && tabs.push(programProductTab);
    professionalLearning && tabs.push(plProductTab);

    return tabs;
  };

  const tabs = getProductTabs();

  useEffect(() => {
    if (!selectedProductTab && tabs?.length > 0) {
      setTabState(tabs[0]?.name);
    }
  }, [selectedProductTab, tabs]);

  return products ? (
    <Tabs selectedTabName={selectedProductTab} className={"products-tabs"}>
      <TabHeaders
        className={clsx(tabs?.length > 1 && "tab-header-border")}
        onSelectedTabChange={setTabState}
      >
        {tabs?.length > 1 &&
          tabs.map(({ header, name }, i) =>
            cloneElement(header, { key: `tab-header-${name}-${i}` })
          )}
      </TabHeaders>
      {tabs.map(({ content, name }, i) =>
        cloneElement(content, { key: `tab-content-${name}-${i}` })
      )}
    </Tabs>
  ) : (
    <NoProductsNotification />
  );
};
